import { Progress } from '@base-ui/react/progress';

import styles from './index.module.scss';
import { Rocket } from './rocket';
import { classNames } from '@/utils/ui/classname';

interface ProgressBarProps extends Omit<React.ComponentProps<typeof Progress.Root>, 'className'> {
  variant?: string;
  hideRocket?: boolean;
  hideValue?: boolean;
  height?: number;
  className?: string;
}

export const ProgressBar = ({
  variant,
  hideRocket = false,
  hideValue = false,
  className = '',
  height = 6,
  ...props
}: ProgressBarProps) => {
  return (
    <Progress.Root {...props} className={classNames(styles.root, className)} data-variant={variant}>
      <Progress.Track className={styles.track} style={{ height: `${height}px` }}>
        <Progress.Indicator className={styles.indicator}>
          {!hideRocket && <Rocket className={styles.rocket} />}
        </Progress.Indicator>
      </Progress.Track>
      {!hideValue && <Progress.Value className={styles.value} />}
    </Progress.Root>
  );
};
